<template>
    <div class="row">
        <div class="col" v-show="initialLoading">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>
        <div class="col">
            <div v-if="!initialLoading" class="row">
                <div class="col col-sm-12 col-md-12" v-for="(conference ,name) in conferences" :key="name">
                    <card>
                        <div slot="header">
                            <h4 class="float-left mb-0 inline"><span class="text-capitalize">{{ name }}</span></h4>
                            <h5 class="float-right mb-0 inline" v-show="loading.conferences">
                                <font-awesome-icon :icon="['fal','spinner-third']"
                                                   spin></font-awesome-icon>
                                Updating.
                            </h5>
                            <h5 class="float-right mb-0 inline" style="color: green" v-show="!loading.conferences">
                                Up-to-date</h5>
                        </div>
                        <el-table
                            :data="conference"
                            max-height="170"
                            size="small">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <p class="ml-4 p-2">Caller ID: {{ props.row.caller_id }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="student.number" label="#" min-width="35"></el-table-column>
                            <el-table-column prop="student.name" label="Name"></el-table-column>
                            <el-table-column label="Muted">
                                <template slot-scope="scope">
                                    <font-awesome-icon v-show="scope.row.muted === true" class="text-warning"
                                                       :icon="['fal','volume-slash']"></font-awesome-icon>
                                    <font-awesome-icon v-show="scope.row.muted === false" class="text-info"
                                                       :icon="['fal','volume-up']"></font-awesome-icon>
                                </template>
                            </el-table-column>
                            <el-table-column
                                header-align="right"
                                align="right"
                                min-width="90"
                                label="Actions">
                                <div slot-scope="{ row,$index}" class="text-right table-actions">
                                    <base-button
                                        v-on:click="kickParticipant(row.event_id)"
                                        type="danger"
                                        class="btn-link">
                                        Kick
                                    </base-button>
                                    <base-button
                                        v-on:click="muteParticipant(row.event_id)"
                                        type="warning"
                                        class="btn-link">
                                        Mute
                                    </base-button>
                                    <base-button
                                        v-on:click="unmuteParticipant(row.event_id)"
                                        type="info"
                                        size="sm"
                                        class="btn-link">
                                        Unmute
                                    </base-button>
                                </div>
                            </el-table-column>
                            <div slot="empty">
                                <span>You have no participants.</span>
                            </div>
                        </el-table>
                    </card>
                </div>


            </div>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "LiveConferenceOverview",
    components: {},
    props: ['classroom'],
    data() {
        return {
            conferences: null,
            updateInterval: 5,
            poller: null,
            initialLoading: true,
            loading: {
                conferences: true,
            }
        };
    },
    mounted() {
        this.loadConferences();
    },
    methods: {
        loadConferences() {
            this.loading.conferences = true;
            return axios({
                url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/conference/live',
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                this.conferences = resp.data.data;
                this.initialLoading = false;
            }).finally(() => {
                this.loading.conferences = false;
                if (window.conferencePoller != undefined && window.conferencePoller != 'undefined') {
                    window.clearInterval(window.window.conferencePoller);
                }
                window.conferencePoller = window.setInterval(() => {
                    this.loadConferences();
                }, this.updateInterval * 1000)
            }).catch(resp => {
                this.$notify({
                    message: 'Could not load your live conferences. Try again later',
                    type: 'danger',
                });
            });
        },
        kickParticipant(event_id) {
            return axios({
                url: this.baseAPIURL + 'conference/live/kick/' + event_id,
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                //    Participant being kicked..
                this.$notify({
                    message: 'Student is being kicked..',
                    type: 'info',
                });
            }).catch(resp => {
                this.$notify({
                    message: 'Unable to send action! Try again later.',
                    type: 'danger',
                });
            });
        },
        muteParticipant(event_id) {
            return axios({
                url: this.baseAPIURL + 'conference/live/mute/' + event_id,
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                //    Participant being muted..
                this.$notify({
                    message: 'Student is being muted..',
                    type: 'info',
                });
            }).catch(resp => {
                this.$notify({
                    message: 'Unable to send action! Try again later.',
                    type: 'danger',
                });
            });
        },
        unmuteParticipant(event_id) {
            return axios({
                url: this.baseAPIURL + 'conference/live/unmute/' + event_id,
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                //    Participant being unmuted..
                this.$notify({
                    message: 'Student is being unmuted..',
                    type: 'info',
                });
            }).catch(resp => {
                this.$notify({
                    message: 'Unable to send action! Try again later.',
                    type: 'danger',
                });
            });
        },
    }
}
</script>

<style scoped>

</style>
